import { API_BASE_URL } from '../../constants';

export const apiRequestPath = (path, params= []) => {
    return API_BASE_URL + path.replace(/\{(.+?)\}/g, j => params[j.replace(/\{|\}/g, '')]);
};
